import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AuthenticationNavigation from '../../components/navigation/AuthenticationNavigation';
import CyberpunkBackground from './components/CyberpunkBackground';
import TerminalHeader from './components/TerminalHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import RegisterPrompt from './components/RegisterPrompt';

const Login = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Login - CyberOddEven | Access Gaming Terminal</title>
        <meta name="description" content="Login to CyberOddEven - Enter the cyberpunk psychological gaming arena and challenge AI opponents with unique personalities in intense odd-even battles." />
      </Helmet>
      <AuthenticationNavigation />
      <CyberpunkBackground />
      <div className="min-h-screen pt-16 pb-8 md:pb-12 lg:pb-16 px-4 md:px-6 lg:px-8 flex items-center justify-center relative z-10">
        <div className="w-full max-w-md lg:max-w-lg">
          <div className="bg-card/80 backdrop-blur-sm border-2 border-primary rounded-sm shadow-glow-cyan-lg p-6 md:p-8 lg:p-10">
            <TerminalHeader />
            <LoginForm />
            <SecurityBadges />
          </div>
          
          <RegisterPrompt />

          <div className="mt-6 md:mt-8 text-center">
            <p className="text-xs md:text-sm font-body text-muted-foreground">
              &copy; {new Date()?.getFullYear()} CyberOddEven. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;